import { render, staticRenderFns } from "./agreement-edit.vue?vue&type=template&id=25074499&"
import script from "./agreement-edit.vue?vue&type=script&lang=ts&"
export * from "./agreement-edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports